var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1617",
    "data-name": "Group 1617",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 28,
    height: 28,
    rx: 14,
    fill: "#293240"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fi-rr-angle-small-right",
    d: "M9.838,9.182l3.839-3.934a.822.822,0,0,1,1.179,0,.859.859,0,0,1,.183.279.877.877,0,0,1,0,.659.859.859,0,0,1-.183.279l-3.848,3.925a.856.856,0,0,0-.183.279.877.877,0,0,0,0,.659.857.857,0,0,0,.183.279l3.848,3.925a.873.873,0,0,1,0,1.213.823.823,0,0,1-1.184,0L9.838,12.816a2.616,2.616,0,0,1,0-3.634Z",
    transform: "translate(0.895 3.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/backBtn.c3e8b2fe17db8003c4bcccefbee1f43a.svg";
export { ForwardRef as ReactComponent };